'use strict';

module.exports = Object.freeze({
    components: {
        dimensions: 'dimensions',
        materialsAndTechniques: 'materialsAndTechniques',
        multiline: 'multiline',
        versions: 'versions',
    },
    title: {
        dealerReference: 'shared.dealerReference',
    },
    availableNow: 'Available Now',
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/constants/detailsConstants.es.js